/** Local calendar date key YYYY-MM-DD (not UTC). */
export function todayDateKey(reference = new Date()): string {
  const y = reference.getFullYear();
  const m = String(reference.getMonth() + 1).padStart(2, "0");
  const d = String(reference.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function startOfLocalDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function isPastDateKey(dateKey: string, reference = new Date()): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateKey)) return false;
  const [y, m, d] = dateKey.split("-").map(Number);
  const target = new Date(y, m - 1, d);
  if (Number.isNaN(target.getTime())) return false;
  return startOfLocalDay(target).getTime() < startOfLocalDay(reference).getTime();
}

export function isTodayOrFutureDateKey(dateKey: string, reference = new Date()): boolean {
  return !isPastDateKey(dateKey, reference);
}
